// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import * as FormData from 'form-data';
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeDocumentsApi = class EdgeDocumentsApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param documentGroupUploadRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentDocumentGroupUpload(documentGroupUploadRequestModel, xProgramId) {
        const _url_ = '/edge/documents/v2/Document/documentGroupUpload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'documentGroupUploadRequestModel' is not null or undefined
        if (documentGroupUploadRequestModel === null || documentGroupUploadRequestModel === undefined) {
            throw new Error('Required parameter documentGroupUploadRequestModel was null or undefined when calling documentDocumentGroupUpload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentGroupUploadRequestModel, "DocumentGroupUploadRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentUploadResponseModel");
        }
        return response;
    }
    /**
     *
     * @param displayId
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentDownload(displayId, xProgramId) {
        const _url_ = '/edge/documents/v1/Document/download/{displayId}'
            .replace('{' + 'displayId' + '}', encodeURIComponent(String(displayId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'displayId' is not null or undefined
        if (displayId === null || displayId === undefined) {
            throw new Error('Required parameter displayId was null or undefined when calling documentDownload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param displayId
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentInline(displayId, xProgramId) {
        const _url_ = '/edge/documents/v1/Document/inline/{displayId}'
            .replace('{' + 'displayId' + '}', encodeURIComponent(String(displayId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'displayId' is not null or undefined
        if (displayId === null || displayId === undefined) {
            throw new Error('Required parameter displayId was null or undefined when calling documentInline.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param type
     * @param attachment
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentUpload(type, attachment, xProgramId) {
        const _url_ = '/edge/documents/v1/Document/upload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling documentUpload.');
        }
        // verify required parameter 'attachment' is not null or undefined
        if (attachment === null || attachment === undefined) {
            throw new Error('Required parameter attachment was null or undefined when calling documentUpload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let formData = new FormData();
        if (type !== undefined) {
            formData.append('type', Serializer.serialize(type, "number"));
        }
        if (attachment !== undefined) {
            formData.append('attachment', attachment);
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: formData,
        };
        if (formData.getHeaders) {
            Object.assign(requestConfig.headers, formData.getHeaders());
        }
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1DocumentUploadUploadResponse");
        }
        return response;
    }
    /**
     *
     * @param documentUploadRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentUpload_1(documentUploadRequestModel, xProgramId) {
        const _url_ = '/edge/documents/v2/Document/upload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'documentUploadRequestModel' is not null or undefined
        if (documentUploadRequestModel === null || documentUploadRequestModel === undefined) {
            throw new Error('Required parameter documentUploadRequestModel was null or undefined when calling documentUpload_1.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentUploadRequestModel, "DocumentUploadRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentUploadResponseModel");
        }
        return response;
    }
    /**
     *
     * @param scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async fillablePdfGenerateFieldsFromFile(scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel, xProgramId) {
        const _url_ = '/edge/documents/v2/FillablePdf/generateFieldsFromFile';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel' is not null or undefined
        if (scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel === null || scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel === undefined) {
            throw new Error('Required parameter scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel was null or undefined when calling fillablePdfGenerateFieldsFromFile.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel, "ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse");
        }
        return response;
    }
    /**
     *
     * @param scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async fillablePdfGenerateFillablePdf(scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel, xProgramId) {
        const _url_ = '/edge/documents/v2/FillablePdf/generateFillablePdf';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel' is not null or undefined
        if (scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel === null || scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel === undefined) {
            throw new Error('Required parameter scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel was null or undefined when calling fillablePdfGenerateFillablePdf.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel, "ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param generatePdfFromHtmlRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async generatePdfFromHtmlDownload(generatePdfFromHtmlRequest, xProgramId) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/download';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'generatePdfFromHtmlRequest' is not null or undefined
        if (generatePdfFromHtmlRequest === null || generatePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter generatePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlDownload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromHtmlRequest, "GeneratePdfFromHtmlRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param generatePdfFromHtmlRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async generatePdfFromHtmlInline(generatePdfFromHtmlRequest, xProgramId) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/inline';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'generatePdfFromHtmlRequest' is not null or undefined
        if (generatePdfFromHtmlRequest === null || generatePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter generatePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlInline.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromHtmlRequest, "GeneratePdfFromHtmlRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param generateAndSavePdfFromHtmlRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async generatePdfFromHtmlSave(generateAndSavePdfFromHtmlRequest, xProgramId) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/save';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'generateAndSavePdfFromHtmlRequest' is not null or undefined
        if (generateAndSavePdfFromHtmlRequest === null || generateAndSavePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter generateAndSavePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlSave.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(generateAndSavePdfFromHtmlRequest, "GenerateAndSavePdfFromHtmlRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1GeneratePdfFromHtmlSaveSaveResponse");
        }
        return response;
    }
    /**
     *
     * @param generatePdfFromTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async generatePdfFromTemplateDownload(generatePdfFromTemplateRequest, xProgramId) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/download';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'generatePdfFromTemplateRequest' is not null or undefined
        if (generatePdfFromTemplateRequest === null || generatePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter generatePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateDownload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromTemplateRequest, "GeneratePdfFromTemplateRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param generatePdfFromTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async generatePdfFromTemplateInline(generatePdfFromTemplateRequest, xProgramId) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/inline';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'generatePdfFromTemplateRequest' is not null or undefined
        if (generatePdfFromTemplateRequest === null || generatePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter generatePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateInline.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromTemplateRequest, "GeneratePdfFromTemplateRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param generateAndSavePdfFromTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async generatePdfFromTemplateSave(generateAndSavePdfFromTemplateRequest, xProgramId) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/save';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'generateAndSavePdfFromTemplateRequest' is not null or undefined
        if (generateAndSavePdfFromTemplateRequest === null || generateAndSavePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter generateAndSavePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateSave.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(generateAndSavePdfFromTemplateRequest, "GenerateAndSavePdfFromTemplateRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1GeneratePdfFromTemplateSaveSaveResponse");
        }
        return response;
    }
};
EdgeDocumentsApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeDocumentsApi);
export { EdgeDocumentsApi };
//# sourceMappingURL=edgeDocumentsApi.js.map